async function uploadFile(params) {
    
}

async function deleteObject(params) {
    
}

export { uploadFile, deleteObject }